module.exports = __webpack_public_path__ + "media/images/help/OpenRounds_Logo-7357e82b581703821042921a861a3ed6.jpeg";